import React from 'react';

const ServicesPage = () => {
    return (
        <div>
            <h1>Services</h1>
            <p>Our services content here.</p>
        </div>
    );
};

export default ServicesPage;